import { DoqFaceSvgProps } from '../types';

const TreemapError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    role="presentation"
  >
    <g clipPath="url(#clip0_2773_48687)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-treemap-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#76D1A5"
        mask="url(#bottom-mask-treemap-error)"
      />

      <mask
        id="mask0_2773_48687"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_2773_48687)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#C07E02"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#C07E02"
      />
      <g opacity="0.5">
        <path
          d="M113.883 255C113.883 253.895 114.778 253 115.883 253H139.883C140.987 253 141.883 253.895 141.883 255V264C141.883 265.105 140.987 266 139.883 266H115.883C114.778 266 113.883 265.105 113.883 264V255Z"
          fill="#C07E02"
        />
        <path
          d="M87.8828 272C87.8828 270.895 88.7782 270 89.8828 270H107.883C108.987 270 109.883 270.895 109.883 272V294C109.883 295.105 108.987 296 107.883 296H89.8828C88.7782 296 87.8828 295.105 87.8828 294V272Z"
          fill="#C07E02"
        />
        <path
          d="M87.8828 253C87.8828 251.895 88.7782 251 89.8828 251H92.8828C93.9874 251 94.8828 251.895 94.8828 253V265C94.8828 266.105 93.9874 267 92.8828 267H89.8828C88.7782 267 87.8828 266.105 87.8828 265V253Z"
          fill="#C07E02"
        />
        <path
          d="M87.8828 242C87.8828 240.895 88.7782 240 89.8828 240H92.8828C93.9874 240 94.8828 240.895 94.8828 242V245C94.8828 246.105 93.9874 247 92.8828 247H89.8828C88.7782 247 87.8828 246.105 87.8828 245V242Z"
          fill="#C07E02"
        />
        <path
          d="M98.8828 242C98.8828 240.895 99.7782 240 100.883 240H107.883C108.987 240 109.883 240.895 109.883 242V265C109.883 266.105 108.987 267 107.883 267H100.883C99.7782 267 98.8828 266.105 98.8828 265V242Z"
          fill="#C07E02"
        />
        <path
          d="M178.883 242C178.883 240.895 179.778 240 180.883 240H229.883C230.987 240 231.883 240.895 231.883 242V294C231.883 295.105 230.987 296 229.883 296H180.883C179.778 296 178.883 295.105 178.883 294V242Z"
          fill="#C07E02"
        />
        <path
          d="M145.883 242C145.883 240.895 146.778 240 147.883 240H172.883C173.987 240 174.883 240.895 174.883 242V264C174.883 265.105 173.987 266 172.883 266H147.883C146.778 266 145.883 265.105 145.883 264V242Z"
          fill="#C07E02"
        />
        <path
          d="M113.883 242C113.883 240.895 114.778 240 115.883 240H139.883C140.987 240 141.883 240.895 141.883 242V247C141.883 248.105 140.987 249 139.883 249H115.883C114.778 249 113.883 248.105 113.883 247V242Z"
          fill="#C07E02"
        />
        <path
          d="M113.883 272C113.883 270.895 114.778 270 115.883 270H172.883C173.987 270 174.883 270.895 174.883 272V294C174.883 295.105 173.987 296 172.883 296H115.883C114.778 296 113.883 295.105 113.883 294V272Z"
          fill="#C07E02"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.851 200.005C159.816 200.082 159 200.946 159 202C159 203.105 159.895 204 161 204H175.5C177.433 204 179 205.567 179 207.5C179 207.67 178.988 207.837 178.964 208.001L179 208.001C179.001 209.105 179.896 210 181 210C182.105 210 183 209.105 183 208C183 207.942 182.997 207.884 182.993 207.826L182.984 208.001C182.994 207.835 183 207.668 183 207.5C183 203.358 179.642 200 175.5 200H161L160.851 200.005Z"
        fill="#C07E02"
      />
    </g>
    <defs>
      <clipPath id="clip0_2773_48687">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { TreemapError };
